import { styled } from 'linaria/react';

const StyledUsers = styled.div<{ dimension: number }>`
  .avatar:last-child {
    margin: ${({ dimension }) => `-${dimension / 1.6}px 0 0 ${dimension / 2.66}px`};
  }
`;

export default StyledUsers;
